module.exports = __webpack_public_path__ + "static/img/湖北南漳县100亿储能基地项目.c4cab3e2.jpg";